/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const AutoDeletePreviewRequestDTOTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the AutoDeletePreviewRequestDTO interface.
 */
export function instanceOfAutoDeletePreviewRequestDTO(value) {
    if (!('targetMarket' in value) || value['targetMarket'] === undefined)
        return false;
    return true;
}
export function AutoDeletePreviewRequestDTOFromJSON(json) {
    return AutoDeletePreviewRequestDTOFromJSONTyped(json, false);
}
export function AutoDeletePreviewRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'targetMarket': json['targetMarket'],
        'filter': json['filter'] == null ? undefined : json['filter'],
    };
}
export function AutoDeletePreviewRequestDTOToJSON(json) {
    return AutoDeletePreviewRequestDTOToJSONTyped(json, false);
}
export function AutoDeletePreviewRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'targetMarket': value['targetMarket'],
        'filter': value['filter'],
    };
}
